import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import config from "./config";

const DefaultLayout = ({ children }) => {
  return (
    <>
      {/* <Header /> */}
      {children}
      {/* <Footer menuItems={config.footer.menuItems} /> */}
    </>
  );
};

export default DefaultLayout;
